export const AuthTestPage = () => {
  return (
    <div>
      <h1>Auth Test Page</h1>
      <p>This page is used to test authentication functionality.</p>
    </div>
  );
};